import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function CostChart({ chartData }) {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: "Évolution des coûts cumulés" }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Nombre d'années"
        }
      },
      y: {
        title: {
          display: true,
          text: 'Coût cumulé (€)'
        }
      }
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow my-4 h-[300px] md:h-[500px]">
      <Line data={chartData} options={options} />
    </div>
  );
}

export default CostChart; 